export enum SpaceType {
	General = 0,
	Staff = 10,
	Player = 20,
	Director = 30,
}